import { render, staticRenderFns } from "./AdditionalInformationDisplay.vue?vue&type=template&id=bee0e44c&scoped=true"
import script from "./AdditionalInformationDisplay.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationDisplay.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformationDisplay.vue?vue&type=style&index=0&id=bee0e44c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee0e44c",
  null
  
)

export default component.exports